// import {testURL} from '../url/index'
import request from '@/util/request'

export function pinyin (data) {
  return request({
    // url: testURL + '/test?param=' + param,
    url: '/noauth/utils/pinyin',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/pinyin.js